import React from "react";

export default function ProductCard ({type = '', product, title, description}) {

    return(
        <div className={type === 'individu' ? 'card-product-individu' : 'card-product-produktif'}>
            <img className="img-back" src={require(`../../../../assets/img/product/${product}.png`)} alt='productImage'></img>
            <div className='content'>
                <div className='top-section'>
                    <h3>
                        <div dangerouslySetInnerHTML={{__html: title}}/>
                    </h3>
                    <p>
                        <div style={{lineHeight:'1.5'}} dangerouslySetInnerHTML={{__html: description}}/>
                    </p>
                </div>
                <div className='bottom-section'>
                    <a href={product}
                       className={`btn-danai ${type === 'individu' ? 'green-outline' : 'blue-outline'}`}>
                        Ajukan
                    </a>
                </div>
            </div>
        </div>
    );
}